import { Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
} from "@angular/material/autocomplete";
import {
  FormGroup,
  FormBuilder,
  ReactiveFormsModule,
  Validators,
  FormsModule,
} from "@angular/forms";
import { NoDataComponent } from "../shared/no-data/no-data.component";
import { InventoryService } from "src/app/service/inventory.service";
import { alertModalDelete, alertModalWithoutConfirm } from "../../helpers/alert";
import { NgClass } from "@angular/common";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";

interface Request {
  value: string;
  viewValue: string;
}

interface ApprovedReturnReq {
  value: string;
  viewValue: string;
}

import { isHrOrItAdminDept } from 'src/app/constants/departments';
@Component({
    selector: "app-return-request",
    providers: [provideNativeDateAdapter()],
    imports: [
        MatFormFieldModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatInputModule,
        MatAutocompleteModule,
        NoDataComponent,
        NgClass,
        InfiniteScrollModule,
        FormsModule,
    ],
    templateUrl: "./return-request.component.html",
    styleUrls: ["./return-request.component.css", "../styles/inventory.css"]
})
export class ReturnRequestComponent {
  requests: Request[] = [
    { value: "Return Request", viewValue: "Return Request" },
    { value: "Extend Request", viewValue: "Extended Request" },
  ];

  uploadAssetImageForm: FormGroup;
  declineReasonForm: FormGroup;
  selectedFiles: any[] = [];
  loggedUserId: any;
  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private inventoryService: InventoryService,
    private route: ActivatedRoute
  ) {
    this.uploadAssetImageForm = this.fb.group({
      assetImage: [],
    });

    this.declineReasonForm = this.fb.group({
      rejectionReason: ["", Validators.required],
    });
  }

  userDepartment: string | null = null;
  showUserDashboard = false;
  showAdminRequest = false;
  
ngOnInit() {
  this.currentPageNume = 1;
this.inventory = [];
  this.getAssignedInventoryData();
  this.getExtendData();
  this.userDepartment = localStorage.getItem("department");
  this.showUserDashboard = isHrOrItAdminDept(this.userDepartment);
  this.showAdminRequest = this.userDepartment === "ADMIN";
  this.loggedUserId = localStorage.getItem("guestID");

  this.route.queryParams.subscribe((params) => {
    const filter = params['filter'];
    console.log('Query param filter received:', filter);
    console.log('Current route:', this.route.snapshot.url);
    
    if (filter) {
      this.handleRequestType(filter as any);
    } else {
      if (this.showUserDashboard) {
        this.handleRequestType('All return');
      } else {
        this.handleRequestType('return');
      }
    }
  });
}

  extendInv = [];
  totalExtend: any;
  getExtendData() {
    this.showReturnHead = false;
    this.showServicePending = true;
    this.currentPageNume = 1;
    this.extendInv = [];

    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };

    this.inventoryService.getExtendRequest(field).subscribe((response) => {
      this.extendInv = response["data"].records;
      this.totalExtend = response["data"].totalCounts;
      this.isShimmerLoading = false;
    });
  }

       deleteExtendRequest(requestId: any){
       const userConfirmed = alertModalDelete(
         "Are you sure you want to delete this request?"
       );
       if (userConfirmed) {
         const declineRequest = {
           requestId: requestId,
           requestType: "Extend Request",
         };
     
         this.inventoryService.deleteAction(declineRequest).subscribe(
           (response) => {
      window.location.reload();
             // this.snackBar.open("Request Declined", "OK");
             this.getExtendData();
           },
           (err) => {
             alertModalWithoutConfirm("error", "Failed to delete the request.");
           }
         );
       }
     }
     

  searchExtendQuery: any;
  searchedExtendInventory = [];
  totalSearchedExtendInv: any;
  onSearchExtendRequest() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalExtend,
      searchQuery: this.searchExtendQuery,
    };
    if (this.searchExtendQuery === "") {
      // this.clearSearch();
    } else {
      this.inventoryService.getExtendRequest(field).subscribe((response) => {
        console.log(response);
        this.searchedExtendInventory = response["data"].records;
        this.extendInv = this.searchedExtendInventory;
        this.totalSearchedExtendInv = response["data"].totalCounts;
        this.totalExtend = this.totalSearchedExtendInv;
      });
    }
  }

  clearExtendSearch() {
    this.searchExtendQuery = "";
    this.getExtendData();
  }

  clearHRReturnSearch() {
    this.searchQuery = "";
    this.getAssignedInventoryData();
  }
  // Shimmer Loader
  isShimmerLoading: boolean = true;
  shimmerLoadingValue = ([] = [1, 2, 3, 4, 5]);

  onRequestSelect(value: string): void {
    console.log("Selected value:", value);
    this.onFilterPendingRequest(value);
  }
  pendingReq: any;
  totalPending: any;
  showReturnHead: boolean = false;
  showServicePending: boolean = false;
  onFilterPendingRequest(
    requestType: string,
    pageNum = this.currentPageNume,
    limit = this.currentLimit
  ) {
    const getPendingReqValue: any = {
      requestType: requestType,
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };

    this.showReturnHead = requestType === "Return Request";
    this.showServicePending = requestType === "Extend Request";

    this.inventoryService
      .getPendingRequest(getPendingReqValue)
      .subscribe((response) => {
        this.pendingReq = response["data"].records;
        this.totalPending = response["data"].totalCounts;
      });
  }
  inventory: any[] = [];
  totalAssigned: any;
  returnReq = []
getAssignedInventoryData() {
  this.showReturnHead = true;
  this.showServicePending = false;

  const field: any = {
    pageNum: this.currentPageNume,
    limit: this.currentLimit,
    searchQuery: this.searchQuery,
  };

  this.inventoryService.getAssignInv(field).subscribe((response: any) => {
    const newItems = (response?.data?.records || []).reverse();

    if (this.currentPageNume === 1) {
      this.inventory = newItems; 
    } else {
      this.inventory = [...this.inventory, ...newItems]; 
    }

    this.totalAssigned = response?.data?.totalCounts || 0;
    this.isShimmerLoading = false;
  });
}



  getAllReturnedRequestForHR(){

  }

  requestSelect: string = '';
  selectedRequestType: "return" | "extend" | "Extend Request" | "Return Request" | "Declined Return Request" | "Declined Extend Request" | "All return" | "All Declined Request" | "Mine return" | "HR approved return" = "return";
handleRequestType(type: "return" | "extend" | "Extend Request" | "Return Request" | "Declined Extend Request" | "Declined Return Request" | "All return" | "All Declined Request" | "Mine return" | "HR approved return") {
  this.selectedRequestType = type;
  this.selectedDeclinedRequestType = type;
  this.selectRequestType = '';
  this.requestSelect = type;
  this.currentPageNume = 1;

  // Reset arrays
  this.inventory = [];
  this.hrReturnInv = [];
  this.returnInv = [];
  this.extendInv = [];
  this.approveInv = [];
  this.declinedExtendInv = [];
  this.declineInv = [];
  this.declineReturnInv = [];

  // Handle each request type
  switch (type) {
    case "return":
    case "Mine return":
      this.getAssignedInventoryData();
      break;
    case "HR approved return":
      this.getHRApprovedRequest("Return Request");
      break;
    case "All return":
      this.getInventoryReturnRequest();
      break;
    case "extend":
      this.getExtendData();
      break;
    case "Extend Request":
      this.getHRApprovedRequest("Extend Request");
      break;
    case "Return Request":
      this.onFilterApprovedRequest(type);
      break;
    case "Declined Extend Request":
      this.onFilterDeclinedExtendRequest('Rejected');
      break;
    case "Declined Return Request":
      this.onFilterDeclinedRequest('Rejected');
      break;
    case "All Declined Request":
      this.getAllDeclinedRequest();
      break;
    default:
      console.warn('Unknown request type:', type);
  }

  this.updatePlaceholder(type);
}


  hrReturnInv = [];
  totalHROwnReturn: any;
  getHROwnReturnRequest() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };
    this.inventoryService.getHROwnReturnRequest(field).subscribe((response:any) => {
      this.hrReturnInv = response.data.records;
      this.totalHROwnReturn = response.data.totalCounts;
      this.isShimmerLoading = false
    });
  }

  hrApprovedInv = [];
  totalHrApproved: any;
  hrApprovedSearchQuery: any;
  getHRApprovedRequest(requestType: string,pageNum =this.currentPageNume , limit= this.currentLimit) {
    this.currentRequestType = requestType;
    this.selectRequestType = requestType;
    this.selectRequestType = '';
    const getApprovedReqValue: any = {
      requestType: requestType,
      pageNum: pageNum,
      limit: limit,
      searchQuery: this.hrApprovedSearchQuery,

    }
 
    if(isHrOrItAdminDept(this.userDepartment) || this.userDepartment === 'ADMIN'){
      getApprovedReqValue.isAll = "true";
    }

    this.inventoryService.getApprovedRequest(getApprovedReqValue).subscribe(response => {
      console.log("Approved Request", response);
      if (pageNum === 1) {
        this.hrApprovedInv = response["data"].records;
      } else {
        this.hrApprovedInv = [...this.hrApprovedInv, ...response["data"].records];
      }
      this.totalHrApproved = response['data'].totalCounts;
    })
  }


  hrApprovedSearchedInv = [];
  totalSearchedHrApproved: any;
    onSearchHRApprovedInventory() {
    const getApprovedReqValue: any = {
      requestType: "Return Request",  
      searchQuery: this.hrApprovedSearchQuery,
      pageNum: this.currentPageNume,
      limit: this.totalHrApproved,
      isAll: "true"
    };

    if (!this.hrApprovedSearchQuery || this.hrApprovedSearchQuery.trim() === "") {
      this.clearHRApprovedSearch();
    } else {
      this.inventoryService
        .getApprovedRequest(getApprovedReqValue)
        .subscribe((response) => {
          console.log("Search Approved Response", response);
          this.hrApprovedSearchedInv = response["data"].records;
          this.hrApprovedInv = this.hrApprovedSearchedInv;

          this.totalSearchedHrApproved = response["data"].totalCounts;
          this.totalHrApproved = this.totalSearchedHrApproved;
        });
    }
  }

  clearHRApprovedSearch() {
    this.hrApprovedSearchQuery = "";
    this.currentPageNume = 1;
    this.hrApprovedInv = [];
    this.getHRApprovedRequest("Return Request", 1, this.currentLimit);
  }

  approveInv = [];
  totalApproved: any;
  currentRequestType: string = '';
  showExtendedApprovedRequest: boolean = false;
  selectRequestType: string = '';
  onFilterApprovedRequest(requestType: string,pageNum =this.currentPageNume , limit= this.currentLimit) {
    this.currentRequestType = requestType;
    this.selectRequestType = requestType;
    this.selectRequestType = '';
    const getApprovedReqValue: any = {
      requestType: requestType,
      pageNum: pageNum,
      limit: limit,
    }

  //     if (this.showUserDashboard) {
  //   getApprovedReqValue.isAll = "true";
  // }

    this.inventoryService.getApprovedRequest(getApprovedReqValue).subscribe(response => {
      console.log("Approved Request", response);
      // this.approveInv = response['data'].records;
      if (pageNum === 1) {
        this.approveInv = response["data"].records;
      } else {
        this.approveInv = [...this.approveInv, ...response["data"].records];
      }
      this.totalApproved = response['data'].totalCounts;
    })
  }


  approvedSearchQuery : any;
  totalSearchedApproved  : any;
  approvedSearchedInv : any;
  onSearchApprovedInventory() {
    const getApprovedReqValue: any = {
      requestType: this.requestSelect,  
      searchQuery: this.approvedSearchQuery,
      pageNum: this.currentPageNume,
      limit: this.totalApproved,
    };
    // if (this.showUserDashboard) {
    //   getApprovedReqValue.isAll = "true";
    // }
  
    if (!this.approvedSearchQuery || this.approvedSearchQuery.trim() === "") {
      this.clearApprovedSearch(); 
    } else {
      this.inventoryService
        .getApprovedRequest(getApprovedReqValue)
        .subscribe((response) => {
          console.log("Search Approved Response", response);
          this.approvedSearchedInv = response["data"].records;
          this.approveInv = this.approvedSearchedInv;

          this.totalSearchedApproved = response["data"].totalCounts;
          this.totalApproved = this.totalSearchedApproved;
        });
    }
  }
  
  clearApprovedSearch() {
    this.approvedSearchQuery = "";
    this.currentPageNume = 1;
    this.approveInv = [];
    this.onFilterApprovedRequest(this.requestSelect, 1, this.currentLimit);
  }
  

  declineInv = [];
  totalDeclined: any;
  showDeclinedRequest: boolean = false;
  selectedDeclinedRequestType = '';
  onFilterDeclinedRequest(
    status: string = "Rejected",
    pageNum = this.currentPageNume,
    limit = this.currentLimit,
    isAll = true
  ) {
    this.selectedDeclinedRequestType = 'Declined Return Request';
    const field: any = {
      pageNum: pageNum,
      limit: limit,
      status: status,
      isAll: isAll,
    };
    this.inventoryService.getHRInvReturnRequest(field)
      .subscribe((response) => {
        this.showDeclinedRequest = true;
        console.log("Approved Request", response);
        // this.declineInv = response["data"].records;
        if (pageNum === 1) {
          this.declineInv = response["data"].records;
        } else {
          this.declineInv = [...this.declineInv, ...response["data"].records];
        }
        this.totalDeclined = response["data"].totalCounts;
      });
  }

  declinedExtendInv = [];
  totalDeclinedExtend: any;
  onFilterDeclinedExtendRequest(
    status: string = "Rejected",
    pageNum = this.currentPageNume,
    limit = this.currentLimit,
    isAll = true
  ) {
    this.selectedDeclinedRequestType = 'Declined Extend Request';
    const field: any = {
      pageNum: pageNum,
      limit: limit,
      status: status,
      isAll: isAll,
    };
    this.inventoryService.getExtendRequest(field)
      .subscribe((response) => {
        this.showDeclinedRequest = true;
        console.log("Approved Request", response);
        // this.declineInv = response["data"].records;
        if (pageNum === 1) {
          this.declinedExtendInv = response["data"].records;
        } else {
          this.declinedExtendInv = [...this.declinedExtendInv, ...response["data"].records];
        }
        this.totalDeclinedExtend = response["data"].totalCounts;
      });
  }

  declinedSearchQuery: any;
  searchedDeclinedInventory = [];
  totalDeclinedSearchedInv: any;
  onSearchDeclinedExtendInventory() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalDeclinedExtend,
      searchQuery: this.declinedSearchQuery,
      status: "Rejected",
    };
  
    if (!this.declinedSearchQuery || this.declinedSearchQuery.trim() === "") {
      this.clearDeclinedExtendSearch();
    } else {
      this.inventoryService.getExtendRequest(field)
        .subscribe((response) => {
          console.log("Search Declined Response", response);
          this.searchedDeclinedInventory = response["data"].records;
          this.declinedExtendInv = this.searchedDeclinedInventory;
          this.totalDeclinedSearchedInv = response["data"].totalCounts;
          this.totalDeclinedExtend = this.totalDeclinedSearchedInv;
        });
    }
  }

  clearDeclinedExtendSearch() {
    this.declinedSearchQuery = "";
    this. onFilterDeclinedExtendRequest("Rejected", 1, this.currentLimit);
  }

  declinedReturnSearchQuery : any;
  searchedDeclinedReturnInv : any;
  totalDeclinedReturnedInv: any;
  onSearchDeclinedReturnInventory() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalDeclined,
      searchQuery: this.declinedReturnSearchQuery,
      status: "Rejected",
    };
  
    if (!this.declinedReturnSearchQuery || this.declinedReturnSearchQuery.trim() === "") {
      this.clearDeclinedReturnSearch();
    } else {
      this.inventoryService.getAssignInv(field)
        .subscribe((response) => {
          console.log("Search Declined Response", response);
          this.searchedDeclinedInventory = response["data"].records;
          this.declineInv = this.searchedDeclinedInventory;
          this.totalDeclinedReturnedInv = response["data"].totalCounts;
          this.totalDeclined = this.totalDeclinedReturnedInv;
        });
    }
  }

  allDeclinedReturnSearchQuery: any;
  searchAllDeclinedReturnInv: any;
  totalAllDeclinedReturnInv: any;
  onSearchAllDeclinedReturnReq(){
  const field: any = {
     pageNum: this.currentPageNume,
      limit: this.allTotalDeclined,
      searchQuery: this.allDeclinedReturnSearchQuery,
      status: "Rejected",
  }
  
  if(!this.allDeclinedReturnSearchQuery || this.allDeclinedReturnSearchQuery.trim() === ""){
    this.clearAllDeclinedReturnReqSearch();
  }
else{
  this.inventoryService.getInvReturnRequest(field).subscribe((response) => {
    console.log("All Declined Search Request" , response);
    this.searchAllDeclinedReturnInv = response["data"].records;
    this.declineReturnInv = this.searchAllDeclinedReturnInv;
    this.totalAllDeclinedReturnInv = response["data"].totalCounts;
    this.allTotalDeclined = this.totalAllDeclinedReturnInv;
  })
}
  }

  clearAllDeclinedReturnReqSearch(){
    this.allDeclinedReturnSearchQuery = ""
   this.getAllDeclinedRequest();
  }


  clearDeclinedReturnSearch() {
    this.declinedReturnSearchQuery = "";
    this. onFilterDeclinedRequest("Rejected", 1, this.currentLimit);
  }
  currentPageNume: number = 1;
  currentLimit: number = 100;
  onScroll() {
    console.log("Scrolled! Current Inventory Length:", this.inventory.length);
    if (this.selectRequestType === 'return') {
      const totalLoaded = this.inventory.length;
      if (totalLoaded >= this.totalAssigned) return;
      this.currentPageNume++;
      this.getAssignedInventoryData();
    }
      if (this.selectRequestType === 'All return') {
      const totalLoaded = this.returnInv.length;
      if (totalLoaded >= this.totalReturn) return;
      this.currentPageNume++;
      this.getInventoryReturnRequest();
    }
    if (this.selectRequestType === 'extend') {
      const totalLoaded = this.extendInv.length;
      if (totalLoaded >= this.totalExtend) return;
      this.currentPageNume++; 
      this.getExtendData();
    }
    if( this.selectRequestType === 'Extend Request' || this.selectRequestType === 'Return Request')
    {
      const totalLoaded = this.approveInv.length;
      if (totalLoaded >= this.totalApproved) return;
      this.currentPageNume++;
      this.onFilterApprovedRequest(this.requestSelect, 1, this.currentLimit);
    }

    if(this.selectRequestType === 'Declined Extend Request'){
      const totalLoaded = this.declinedExtendInv.length;
      if (totalLoaded >= this.totalDeclinedExtend) return;
      this.currentPageNume++;
      this.onFilterDeclinedExtendRequest('Rejected', 1, this.currentLimit);
    }
    if(this.selectRequestType === 'Declined Return Request'){
      const totalLoaded = this.declineInv.length;
      if (totalLoaded >= this.totalDeclined) return;
      this.currentPageNume++;
      this.onFilterDeclinedRequest('Rejected', 1, this.currentLimit);
    }
    if(this.selectRequestType === 'All Declined Request'){
      const totalLoaded = this.declineReturnInv.length;
      if (totalLoaded >= this.allTotalDeclined) return;
      this.currentPageNume++;
      this. getAllDeclinedRequest()
    }
  }

  searchQuery: any;
  searchedInventory = [];
  totalSearchedInv: any;
  onSearchReturnRequest() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalAssigned,
      searchQuery: this.searchQuery,
    };
    if (this.searchQuery === "") {
      this.clearHRReturnSearch();
    } else {
      this.inventoryService.getAssignInv(field).subscribe((response) => {
        console.log(response);
        this.searchedInventory = response["data"].records;
        this.inventory = this.searchedInventory;
        this.totalSearchedInv = response["data"].totalCounts;
        this.totalAssigned = this.totalSearchedInv;
      });
    }
  }



  searchAllReturnQuery: any;
  searchedAllRetunedInv = [];
  totalAllReturnedInv: any;
  onSearchAllReturnRequest(){
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalReturn,
      searchQuery: this.searchAllReturnQuery,
    };

    if(!this.searchAllReturnQuery || this.searchAllReturnQuery.trim() === ""){
      this.clearAllReturnedSearchedInv();
    }
    else{
      this.inventoryService.getInvReturnRequest(field).subscribe((response) =>{
        console.log(response);
        this.searchedAllRetunedInv = response["data"].records;
        this.returnInv = this.searchedAllRetunedInv;
        this.totalAllReturnedInv = response["data"].totalCounts;
        this.totalReturn = this.totalAllReturnedInv;
      })
    }
  }
  clearAllReturnedSearchedInv(){
  this.searchAllReturnQuery = "";
  this.getInventoryReturnRequest();
  }

  assignedInventoryId: string;
  selectedInventoryIndex: number | null = null;
  openReturn(assignedInventoryId: string, index: number) {
    this.assignedInventoryId = assignedInventoryId;
    this.selectedInventoryIndex = index;

    this.uploadAssetImageForm.reset();
    this.selectedFiles = [];
    this.showForwardSuccess = false;
    this.uploadAssetImageForm.get("assetImage").enable();
  }

  // ASSET RETURN REQUEST ACCEPT
  acceptReturnRequest(requestId: any) {
    const acceptRequest = {
      action: "Accept",
      requestId: requestId,
      requestType: "Return Request",
      redirectUrl: `${environment.redirectUrl}#/inventory/return-request?filter=Return Request`,
    };
    this.inventoryService.adminAction(acceptRequest).subscribe((response) => {
      console.log("called" ,requestId);
      alertModalWithoutConfirm("success", "Request has been Approved!");
      window.location.reload();
      // this.getInventoryReturnRequest();
    });
  }

  previewReturnImg: any;
  openReturnPreviewSlider(index: number) {
    this.previewReturnImg = this.returnInv[index];
    this.declineReasonForm.reset();
    this.showDeclineForm = false;
  }

  
  returnInv = [];
  totalReturn: any;
  getInventoryReturnRequest() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };
    this.inventoryService.getInvReturnRequest(field).subscribe((response:any) => {
      this.returnInv = response.data.records;
      this.totalReturn = response.data.totalCounts;
      this.isShimmerLoading = false
    });
  }

  declineReturnInv = [];
  allTotalDeclined: any;
  getAllDeclinedRequest(){
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
      status: "Rejected"
    };
 this.inventoryService.getInvReturnRequest(field).subscribe((response:any) => {
  this.declineReturnInv = response.data.records;
  this.allTotalDeclined = response.data.totalCounts
 })
  }

  showDeclineForm: boolean = false;
  onDeclineButtonClick() {
   this.showDeclineForm = true;
   this.getInventoryReturnRequest();
  }
  // ASSET RETURN REQUEST REJECT
  rejectReturnRequest(requestId: any) {
    const rejectValue = {
      ...this.declineReasonForm.value,
    };
    const getRejectValue = {
      rejectionReason: rejectValue.rejectionReason,
      action: "Rejected",
      requestId: requestId,
      requestType: "Return Request",
      redirectUrl: `${environment.redirectUrl}#/inventory/return-request?filter=Declined Return Request`,
    };
    this.inventoryService.adminAction(getRejectValue).subscribe((response) => {
      console.log("Decline request", response);
       this.showDeclineForm = true;
       alertModalWithoutConfirm(
        "success",
        "Return Request has been declined successfully."
      );
      setTimeout(() => {
      window.location.reload();
    }, 1500);
    });
  }

  onFileSelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      const files = event.target.files;

      if (files.length + this.selectedFiles.length > 4) {
        alert("You can only upload a maximum of 4 files.");
        return;
      }

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.selectedFiles.push({
            file: file,
            name: file.name,
            size: (file.size / 1024).toFixed(2) + " KB",
            preview: e.target.result,
          });
        };
        reader.readAsDataURL(file);
      }

      console.log("Selected Files", this.selectedFiles);

      if (this.selectedFiles.length >= 4) {
        this.uploadAssetImageForm.get("assetImage").disable();
      }
    }
  }

  showForwardSuccess = true;
  isReturnRequestedMap: { [id: string]: boolean } = {};
onReturnSubmit() {
  console.log(this.uploadAssetImageForm.value);

  if (this.selectedFiles.length === 0) {
    return alertModalWithoutConfirm(
      "warning",
      `Please upload at least 1 image.`
    );
  }

  const formData = new FormData();
  formData.append("assignedInventoryId", this.assignedInventoryId);
    formData.append(
    "redirectUrl",
    `${environment.redirectUrl}#/inventory/return-request`
  );

  this.selectedFiles.forEach((fileData: any, index: number) => {
    formData.append(`files[${index}]`, fileData.file, fileData.name);
  });

  this.inventoryService.addAssignedReturn(formData).subscribe(
    (res) => {
      this.showForwardSuccess = true;
      console.log("success");

      this.isReturnRequestedMap[this.assignedInventoryId] = true;

      this.getAssignedInventoryData();
      // setTimeout(() => {
      //   window.location.reload();
      // }, 2000);
    },
    (err) => {
      console.error("failed", err);
    }
  );
}


  removeFile(file: any) {
    const index = this.selectedFiles.indexOf(file);
    if (index > -1) {
      this.selectedFiles.splice(index, 1);
    }
    if (this.selectedFiles.length < 4) {
      this.uploadAssetImageForm.get("assetImage").enable();
    }
  }

  //ACCEPT EXTEND REQUEST
  async acceptExtendRequest(requestId: any) {
    const acceptRequest = {
      action: "Accept",
      requestId: requestId,
      requestType: "Extend Request",
      redirectUrl: `${environment.redirectUrl}#/inventory/return-request?filter=Extend Request`,
    };
    this.inventoryService.adminAction(acceptRequest).subscribe((response) => {
      alertModalWithoutConfirm("success", "Request has been Approved!");
      this.snackBar.open("Accepted", "OK");
      console.log("called");
      this.getExtendData();
    });
  }

  async declineExtendRequest(requestId: any) {
    const acceptRequest = {
      action: "Rejected",
      requestId: requestId,
      requestType: "Extend Request",
      redirectUrl: `${environment.redirectUrl}#/inventory/return-request?filter=Declined Extend Request`,

    };
    this.inventoryService.adminAction(acceptRequest).subscribe((response) => {
      alertModalWithoutConfirm("success", "Request Declined!");
      // this.snackBar.open("Declined", "OK");
      console.log("called");
      this.getExtendData();
    });
  }

    selectedPlaceholder: string = 'Return Request';

updatePlaceholder(value: string) {
  const placeholderMap = {
    'All return': 'Return Request',
    'Mine return': 'Return Request(Mine)',
    'return': 'Return Request',
    'extend': 'Extended Request',
    'Extend Request': 'Approved Extended Request(All)',
    'Declined Extend Request': 'Declined Extended Request',
    'Return Request': 'Approved Returned Request',
    'HR approved return': 'Approved Returned Request(All)',
    'Declined Return Request': 'Declined Returned Request',
    'All Declined Request': 'Declined Returned Request'
  };
  
  this.selectedPlaceholder = placeholderMap[value] || 'Return Request';
}
}
